const LISTE_OT_IMPRESSION = {
  title: 'Ordres de travail - Impression',
  breadcrumb: {
    ordresTravails: 'Ordres de travail impression',
  },
  tabs: {
    enseigne: 'Enseigne',
    campagne: 'Campagne ',
    typeMateriel: 'Type de matériel',
    qteAImprimer: 'Qte à imprimer',
    visuelCampagne: 'Visuel campagne',
    graphisteEnCharge: 'Graphiste en charge',
    etats: 'Etat(s)',
    technicienEnCharge: 'Technicien en charge',
    childrow: {
      code: 'Code OT',
      type: 'Type',
      etat: 'Etat',
      nomSite: 'Nom du site',
      qteAImprimer: 'Qte à imprimer',
      dateDemande: 'Date de la commande',
      materielFormatLibelles: 'Format',
      contactDemandeur: 'Demandeur',
      graphisteEnCharge: 'Graphiste en charge',
      technicienEnCharge: 'Technicien en charge',
    },
  },
  filtre: {
    code: 'Code(s)',
    type: 'Type(s)',
    etat: 'Etat(s)',
    dateSouhaite: 'Date d\'impression',
    campagne: 'Campagnes(s)',
    lieuxLivraison: 'Lieu(x) de livraison(s)',
    nomSite: 'Nom(s) du site',
    dispositif: 'Dispositif(s)',
    typeMateriel: 'Type(s) matériel',
    enseigne: 'Enseigne(s)',
    tag: 'Tag(s) demande impression',
    otTag: 'Tag(s) ordres de travail',
  },
  actions: {
    editionMasse: 'Générer les éditions',
    etatAExpedier: 'A expédier',
    etatRealise: 'Réaliser',
    prisEnCharge: 'Prendre en charge',
  },
  popup: {
    msgAExpedierOt: 'Êtes-vous sûr de vouloir mettre l\'état à "à expédier" vos ordres de travail ?',
    msgRealiseOt: 'Êtes-vous sûr de vouloir mettre l\'état à "réalisé" vos ordres de travail ?',
  },
  error: {
    dates: 'La date de début du filtre par date souhaitée est plus grande que sa date de fin',
  },
  resume: {
    sansMaterielType: 'Sans type de matériel',
  },
  popUpPriseEnCharge: {
    title: 'Êtes-vous sûr de vouloir prendre en charge ces ordres de travail ?',
    titleSingle: 'Êtes-vous sûr de vouloir prendre en charge cet ordre de travail ?',
    success: 'Prise en charge effectuée avec succès',
  },
  popUpSelectionTechnicien: {
    selectTechnicien: 'Technicien',
    etatSouhaite: 'Etat souhaité',
    dateRealisation: 'Date de réalisation',
    datePlanification: 'Date de planification',
  },
};

export default LISTE_OT_IMPRESSION;
